export const RULE_CONFIG_INPUT_TYPE = {
  CURRENCY: "CURRENCY",
  FLOAT: "FLOAT",
  INTEGER: "INTEGER",
  STRING: "STRING",
};
